export default "__VITE_ASSET__BP4AgC0P__"